var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDenmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39134 10.4348H23.8984C23.1314 4.54697 18.0969 0 12 0C11.104 0 10.2313 0.0990469 9.3913 0.285234V10.4348H9.39134Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26084 10.4347V1.45908C2.96586 3.25692 0.607016 6.55462 0.101562 10.4348H6.26084V10.4347Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2608 13.5652H0.101562C0.607016 17.4454 2.96586 20.7431 6.26084 22.5409L6.2608 13.5652Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3913 13.5652V23.7148C10.2313 23.901 11.104 24 12 24C18.0969 24 23.1314 19.453 23.8984 13.5652H9.3913V13.5652Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDenmark);
export default __webpack_public_path__ + "static/media/denmark.c4ca93039dc3e6c79aaf6180666ff91a.svg";
export { ForwardRef as ReactComponent };